import DataTable from "primevue/datatable";
import Column from "primevue/column";
import travellaHeader from "../TravellaHeader.js";
import SettingsService from "../../shared/settings/settings.service.js";

export default {
    name: "best-promocja",
    components: {
        DataTable,
        Column,
        travellaHeader
    },
    props: [],
    data: function() {
        return {
            dane: [],
            tablicaOstatnichMiejsc: [],
            login: "",
            userInfoProfile: {}
        };
    },
    computed: {},
    mounted() {
        this.sprawdzUsera();
        this.wczytajDane();
        this.$nextTick(() => {
            travellaHeader.loadHeader();
        });
    },
    methods: {
        wczytajDane() {
            this.$http
                .get(`${SettingsService.wakacyjny}`)
                .then((response) => {
                    this.dane = response.body;
                    this.sprawdzMiejsce();
                });
        },
        sprawdzUsera() {
            const userInfo = localStorage.getItem(SettingsService.profile);
            const userInfoJSON = JSON.parse(userInfo);
            this.userInfoProfile = userInfoJSON.profile;
            this.login = userInfoJSON.profile.name.toLowerCase();
            return userInfoJSON.profile.name.toLowerCase();
        },
        sprawdzMiejsce() {
            this.dane.forEach((element, index) => {
                if(element.odzial.toLowerCase() == this.login.substring(0,4)) {
                    this.tablicaOstatnichMiejsc.push(index);
                }
                else if (element.odzial.toLowerCase() == this.login) {
                    this.tablicaOstatnichMiejsc.push(index);
                }
            });
        },
        czyPokazacWyniki() {
            const loginyWykluczone = ['k.dabek','kgac','Andrzej']
            if (this.login && loginyWykluczone.find((loginWykluczony) => loginWykluczony.toLowerCase() == this.login)) {
                return false;
            }
            return true;
        }
    }
};
